// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDtfHqD0eDTld4E0G6d_1vL1agHM1-HSd8",
  authDomain: "globepawa-ventures.firebaseapp.com",
  databaseURL: "https://globepawa-ventures-default-rtdb.firebaseio.com",
  projectId: "globepawa-ventures",
  storageBucket: "globepawa-ventures.firebasestorage.app",
  messagingSenderId: "267296206410",
  appId: "1:267296206410:web:f81b9870cad07ff2c140b3",
  measurementId: "G-CX88LQYE70"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export {analytics};